/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { JSXInternal } from 'preact/src/jsx';

type SVGTextAttrs = JSXInternal.SVGAttributes<SVGTextElement>;

type TextProps = {
  text: string;
  props: SVGTextAttrs;
  dataProps?: Record<`data-oj-${string}`, string | undefined>;
  id?: string;
  class?: string;
  style?: SVGTextAttrs['style'];
  isRotated: boolean;
  isRtl: boolean;
  isTruncated?: boolean;
};

export function SinglelineText({
  text,
  style,
  dataProps,
  props,
  id,
  isRotated,
  isRtl,
  isTruncated,
  ...otherProps
}: TextProps) {
  const { x, y } = props;
  const transform = isRotated
    ? `matrix(0, ${isRtl ? 1 : -1}, ${isRtl ? -1 : 1}, 0, ${x}, ${y})`
    : undefined;
  return (
    <text
      {...props}
      {...dataProps}
      id={id}
      className={otherProps.class}
      style={style}
      x={isRotated ? undefined : x}
      y={isRotated ? undefined : y}
      transform={isRotated ? transform : undefined}>
      {text}
    </text>
  );
}
